import Select from 'react-select'
import { ArvUnqualifyIcon } from '../../assets/arv/ArvUnqualifyIcon'
import { ArvQualifiedIcon } from '../../assets/arv/ArvQualifiedIcon'
import { ReactComponent as CheckIcon } from '../../assets/arv/check.svg'
import { ReactComponent as DeleteIcon } from '../../assets/pipeline/delete.svg'
import { ReactComponent as ShareIcon } from '../../assets/arv/share.svg'

const STATUS_OPTIONS = [
  { value: 'All',    label: 'All' },
  { value: 'Active', label: 'On Market' },
  { value: 'Sold',   label: 'Sold' },
]

const labelCls = 'block text-[12px] text-brand-secondary mb-[4px]'

const inputCls = `
  h-[40px] w-[80px] rounded-md border border-brand-muted bg-white
  text-[13px] text-brand-dark text-center
  focus:outline-none focus:border-brand-green px-[8px]
  hover:border-brand-green
  placeholder:text-brand-disabled
  
`.trim()

const toggleBtnCls = 'flex items-center gap-x-[6px] h-[32px] w-[48px] px-[10px] font-semibold rounded-full border transition-colors hover:border-brand-green hover:text-brand-green'

const selectStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #DAE4D5',
    borderRadius: 6,
    boxShadow: 'none',
    minHeight: 40,
    fontSize: 13,
    cursor: 'pointer',
    backgroundColor: 'white',
    '&:hover': { borderColor: '#4CBC18' },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#E7F0E2' : state.isFocused ? '#f8fef4' : '#fff',
    color: '#17270D',
    fontSize: 13,
    cursor: 'pointer',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  indicatorSeparator: () => ({ display: 'none' }),
  input: (base) => ({ ...base, caretColor: 'transparent' }),
}

function ChevronDown() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default function ComparableFilterRow({ filters, gridCount, onFiltersChange, onFiltersBlur, visibleCount, hiddenCount, showVerify }) {
  const set = (field) => (e) => onFiltersChange({ ...filters, [field]: e.target.value })
  const excludedBtnSel = filters.archivedView === 'archived' ? ' text-brand-green border-brand-green' : 'text-[#4F5F4A] border-brand-headBdr' 
  const includedBtnSel = filters.archivedView === 'active' ? ' text-brand-green border-brand-green ': 'text-[#4F5F4A] border-brand-headBdr'


  return (
    <div className="flex items-end justify-between mt-6">

      {/* Left — filters */}
      <div className="flex items-end justify-between gap-x-[14px] w-[885px]">
        <span className='flex gap-x-[14px]'>
        {/* Status */}
          <div className="flex flex-col" style={{ width: 100 }}>
            <span className={labelCls}>Status</span>
            <Select
              value={STATUS_OPTIONS.find(o => o.value === (filters.status ?? 'All'))}
              options={STATUS_OPTIONS}
              onChange={(opt) => {
                const next = { ...filters, status: opt?.value ?? 'All' }
                onFiltersChange(next)
                onFiltersBlur?.(next)
              }}
              styles={selectStyles}
              menuPortalTarget={document.body}
              isSearchable={false}
              placeholder="All"
            />
          </div>

          {/* Price (000s) */}
          <div className="flex flex-col">
            <span className={labelCls}>Price (000s)</span>
            <div className="flex items-center gap-x-[2px]">
              <input
                type="number"
                value={filters.priceMin ?? ''}
                onChange={set('priceMin')}
                onBlur={() => onFiltersBlur?.(filters)}
                placeholder="Min"
                className={inputCls}
              />
              <span className="text-[13px] text-brand-unselectedGray">-</span>
              <input
                type="number"
                value={filters.priceMax ?? ''}
                onChange={set('priceMax')}
                onBlur={() => onFiltersBlur?.(filters)}
                placeholder="Max"
                className={inputCls}
              />
            </div>
          </div>

          {/* Sqft */}
          <div className="flex flex-col">
            <span className={labelCls}>Sqft</span>
            <div className="flex items-center gap-x-[2px]">
              <input
                type="number"
                value={filters.sqftMin ?? ''}
                onChange={set('sqftMin')}
                onBlur={() => onFiltersBlur?.(filters)}
                placeholder="Min"
                className={inputCls}
              />
              <span className="text-[13px] text-brand-unselectedGray">-</span>
              <input
                type="number"
                value={filters.sqftMax ?? ''}
                onChange={set('sqftMax')}
                onBlur={() => onFiltersBlur?.(filters)}
                placeholder="Max"
                className={inputCls}
              />
            </div>
          </div>

        </span>

        <div className="flex pb-[8px] gap-x-[4px] items-center ">
          <span className="text-[12px] text-brand-secondary  h-[20px] bg-[#EDF8E7] px-1 mr-2 rounded">
            { gridCount } Results
          </span>
          {/* show Qualified */}
          <button
            onClick={filters.archivedView !== 'active'? () => {
              const next = { ...filters, archivedView: 'active' }
              onFiltersChange(next)
              onFiltersBlur?.(next)
            }: undefined}
            className={toggleBtnCls + includedBtnSel}
            // style={filters.archivedView === 'active'
            //   ? { borderColor: '#4CBC18', color: '#4CBC18' }
            //   : { borderColor: '#AEC49F', color: '#4F5F4A' }
            // }
          >
            <CheckIcon />
            <span className="text-[13px] font-medium">{visibleCount ?? 0}</span>
          </button>
          {/* show archived */}
          <button
            onClick={() => {
              const next = { ...filters, archivedView: 'archived' }
              onFiltersChange(next)
              onFiltersBlur?.(next)
            }}
            className={toggleBtnCls + excludedBtnSel}
            // style={filters.archivedView === 'archived'
            //   ? { borderColor: '#4CBC18', color: '#4CBC18' }
            //   : { borderColor: '#AEC49F', color: '#4F5F4A' }
            // }
          >
            <DeleteIcon />
            <span className="text-[13px] font-medium">{hiddenCount ?? 0}</span>
          </button>
        </div>

      </div>

    </div>
  )
}
